module.exports = __webpack_public_path__ + "static/media/bacon.865a4565.svg";